import { DisplayCurrency } from '@core/interfaces/displayCurrency';
import {Environment} from '@interfaces/environments';
import packageInfo from '../../package.json';

export const environment: Environment = {
  production: true,
  showPartialPayed: false,
  hasMultipleAgencies: false,
  hasReferredUsers: false,
  showSecondsLanguages: false,
  hasTraedores: false,
  hasReservationBoat: false,
  hasBorrowers: false,
  hasSalesRestrictions: false,
  hasPriceWithTax: false,
  hasFlightNumber: false,
  hasReservationProcessing: false,
  hasReservationModification: false,
  hasBidaiondo: true,
  hasLinkeao: false,
  hasCredit: true,
  hasPeopleGoTo: false,
  hasAdg: false,
  hasAgencyReservations: true,
  hasPagoEnTransito: true,
  dateRangeForDayByDefault: true,
  showDescriptionInVoucher: false,
  isOkaturs: false,

  BoatLabel: 'Embarcaciones',
  BoatIcon: 'sailing',
  //
  apiUrl: 'https://apiexperiencias.marinasmarlin.com/v1/',
  imageUrl: 'https://apiexperiencias.marinasmarlin.com/v1/',
  securityUrl: 'https://apiseg.marinasmarlin.com/v1/',

  marketType: 'international',
  agencyName: 'Marinas Marlin',
  agency: 'marlin',

  imgError: '',
  ServiceBusiness: 'Experiencias',
  defaultLanguage: {
    name: 'Español',
    image: 'assets/images/flags/es.png',
    lang: 'es'
  },
  defaultCurrency: 'USD',
  defaultDisplayCurrency: DisplayCurrency.code,
  defaultMarket: {
    lat: 23.110774,
    lng: -82.440937
  },
  gateway: {
    visa: 'bidaiondo',
    mastercard: 'bidaiondo',
    'american-express': 'bidaiondo',
    jcb: 'bidaiondo',
    dinners: 'bidaiondo',
    iupay: 'bidaiondo',
    maestro: 'bidaiondo',
    virtual: 'bidaiondo',
    electron: 'bidaiondo',
    bizum: 'bidaiondo',
    discover: 'bidaiondo',
    adg: 'adg',
    'transferencia-QR': 'transferencia-QR',
    'in-transit': 'in-transit',
    sber: 'sber'
  },
  versions: {
    app: packageInfo.version
  },
  domain: 'marinasmarlin.com',
  gdsServices: [
    {
      icon: 'timeline',
      id: 'dashboard',
      route: 'https://portalventas.marinasmarlin.com',
      name: 'Dashboard',
      isActive: false
    },
    {
      icon: 'apartment',
      id: 'hotel',
      route: 'https://adminhoteles.marinasmarlin.com',
      name: 'Hoteles',
      isActive: false
    },
    {
      icon: 'flight',
      id: 'flight',
      name: 'Charter',
      route: 'https://adminvuelos.marinasmarlin.com/',
      isActive: false
    },
    {
      icon: 'local_play',
      id: 'experiences',
      name: 'Experiencias',
      route: 'https://adminexperiencias.marinasmarlin.com/',
      isActive: true
    },
    {
      icon: 'local_taxi',
      id: 'car',
      route: 'https://adminautos.marinasmarlin.com/',
      name: 'Autos',
      isActive: false
    },
    {
      icon: 'house',
      id: 'house',
      name: 'Casas',
      route: 'https://admincasas.marinasmarlin.com/',
      isActive: false,
    },
    {
      icon: 'airport_shuttle',
      id: 'transfer',
      name: 'Transfer',
      route: 'https://admintransfer.marinasmarlin.com/',
      isActive: false
    }
  ]
};
